__turbopack_context__.v({
  "checked": "SegmentedControls-module-scss-module__RsnWwq__checked",
  "container": "SegmentedControls-module-scss-module__RsnWwq__container",
  "dark": "SegmentedControls-module-scss-module__RsnWwq__dark",
  "input": "SegmentedControls-module-scss-module__RsnWwq__input",
  "item": "SegmentedControls-module-scss-module__RsnWwq__item",
  "label": "SegmentedControls-module-scss-module__RsnWwq__label",
  "light": "SegmentedControls-module-scss-module__RsnWwq__light",
});
